(function(){
  function openReleasit(){
    var floating = document.querySelector('._rsi-buy-now-button-floating');
    if(floating){
      floating.style.cssText = 'display:block!important;visibility:visible!important;opacity:1!important;position:fixed;bottom:20px;left:50%;transform:translateX(-50%);z-index:99999';
      var inner = floating.querySelector('div, button, a');
      if(inner) inner.click();
      else floating.click();
    }
  }
  function init(){
    var floating = document.querySelector('._rsi-buy-now-button-floating');
    if(!floating){ setTimeout(init, 500); return; }
    floating.style.cssText = 'display:block!important;visibility:visible!important;opacity:1!important;position:fixed;bottom:20px;left:50%;transform:translateX(-50%);z-index:99999';
    document.querySelectorAll('.rsi-trigger-btn, .btn-main').forEach(function(el){
      el.addEventListener('click', function(e){
        e.preventDefault();
        e.stopPropagation();
        openReleasit();
      });
    });
  }
  document.addEventListener('DOMContentLoaded', function(){
    setTimeout(init, 1500);
  });
})();